module.exports = __webpack_public_path__ + "static/media/icn_scroller_card1.d551d012.svg";